module.exports = __webpack_public_path__ + "static/media/Members.d4dbcbf8.svg";